import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { connect } from "react-redux";
import $ from "jquery";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";
import { apiUrl, headerconfig } from "../Settings/Config";
import {
  showLoader,
  userID,
  hideLoader,
  showAlert,
  isEmpty,
  isSingleSelect,
  showContaimerLoader,
} from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
var module = "users/";
var moduleName = "User";
class Form extends Component {
  constructor(props) {
    super(props);
    var editID = this.props.location.state?.editID || "";
    this.state = {
      editID: editID,
      userID: userID(),
      postdata: {
        userRoleID: "",
        userEmpID: "",
        userName: "",
        userPassword: false,
        userAllowShowAll: "",
        status: "",
      },
      detaildata: [],
      roleList: [],
      employeeList: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    this.loadRole();
    this.loadEmployee();
    if (this.state.editID !== "") {
      var params = {
        params:
          "&userID=" + this.state.userID + "&detail_id=" + this.state.editID,
        url: module + "details",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost !== nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "success") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push("/" + module);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.detaildata !== nextProps.detaildata &&
      nextProps.detaildata !== "" &&
      this.state.editID !== ""
    ) {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var userStatus = result.userStatus === "A" ? "Active" : "In Active";
          var status =
            result.userStatus !== "" && result.userStatus !== null
              ? {
                  label: userStatus,
                  value: result.userStatus,
                }
              : "";
          var clientupdatedata = {
            userRoleID: result.userRoleID !== null ? result.userRoleID : "",
            userEmpID: result.userEmpID,
            userName: result.userName,
            userPassword: "",
            userAllowShowAll: result.userAllowShowAll === "1" ? true : false,
            status: status,
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push("/" + module);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }
  loadRole() {
    var urlShringTxt =
      apiUrl + "userroles/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ roleList: res.data.result });
      }
    });
  }
  loadEmployee() {
    var urlShringTxt =
      apiUrl + "employee/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ employeeList: res.data.result });
      }
    });
  }

  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;

    var postObject = {
      userRoleID: postData.userRoleID?.value,
      userEmpID: postData.userEmpID?.value,
      status:
        Object.keys(postData.status).length > 0 ? postData.status?.value : "A",
      userAllowShowAll: postData.userAllowShowAll === true ? 1 : 0,
      userID: this.state.userID,
    };

    var post_url = module + "add";
    if (this.state.editID !== "") {
      postObject["edit_id"] = this.state.editID;
      if (postData.userPassword !== "") {
        postObject["password"] = postData.userPassword;
      }
      post_url = module + "update";
    } else {
      postObject["username"] = postData.userName;
      postObject["password"] = postData.userPassword;
    }
    this.props.getFormPost(postObject, post_url, "add");
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="users" />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={"/" + module}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            roleList={this.state.roleList}
                            employeeList={this.state.employeeList}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop:
                                        $(document)
                                          .find("#modulefrm .error:first")
                                          .offset().top - 100,
                                    },
                                    500
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, postType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, postType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { userRoleID, userEmpID, userName, userPassword, status } =
    props.fields;
  if (props.editID !== " ") {
    return {
      fields: ["userRoleID", "userEmpID", "userName", "status"],
      validations: {
        userRoleID: [[isSingleSelect, userRoleID]],
        userEmpID: [[isSingleSelect, userEmpID]],
        userName: [[isEmpty, userName]],
        status: [[isSingleSelect, status]],
      },
    };
  } else {
    return {
      fields: ["userRoleID", "userEmpID", "userName", "userPassword", "status"],
      validations: {
        userRoleID: [[isSingleSelect, userRoleID]],
        userName: [[isEmpty, userName]],
        userEmpID: [[isSingleSelect, userEmpID]],
        userPassword: [[isEmpty, userPassword]],
        status: [[isSingleSelect, status]],
      },
    };
  }
}

class PostForm extends Component {
  goBack() {
    this.props.history.push("/users");
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handleCheckChange(name, e) {
    this.props.onChange(name, e.target.checked);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsguserRoleID,
      errMsguserEmpID,
      errMsguserName,
      errMsguserPassword,
      errMsgStatus = "";

    if ($validation.userEmpID.error.reason !== undefined) {
      errMsguserEmpID = $validation.userEmpID.show && (
        <span className="error">{$validation.userEmpID.error.reason}</span>
      );
    }

    if ($validation.userName.error.reason !== undefined) {
      errMsguserName = $validation.userName.show && (
        <span className="error">{$validation.userName.error.reason}</span>
      );
    }
    /* if ($validation.userPassword.error.reason !== undefined) {
      errMsguserPassword = $validation.userPassword.show && (
        <span className="error">{$validation.userPassword.error.reason}</span>
      );
    } */
    if ($validation.status.error.reason !== undefined) {
      errMsgStatus = $validation.status.show && (
        <span className="error">{$validation.status.error.reason}</span>
      );
    }

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-3">
              <label className="form-label">
                User Role<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.userRoleID}
                onChange={this.handleSelectChange.bind(this, "userRoleID")}
                placeholder="Select User Role"
                isClearable={true}
                options={this.props.roleList}
              />
              {errMsguserRoleID}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                User Role<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.userEmpID}
                onChange={this.handleSelectChange.bind(this, "userEmpID")}
                placeholder="Select Employee"
                isClearable={true}
                options={this.props.employeeList}
              />
              {errMsguserEmpID}
            </div>

            <div className="form-group col-md-4">
              <label className="form-label">
                User Name<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="User Name"
                name="userName"
                value={fields.userName}
                {...$field("userName", (e) =>
                  onChange("userName", e.target.value)
                )}
                maxLength={255}
                disabled={this.props.editID !== "" ? true : false}
              />
              {errMsguserName}
            </div>
            <div className="form-group col-md-4">
              <label className="form-label">
                Password
                {this.props.editID === "" && (
                  <span className="lbl-error">*</span>
                )}
              </label>
              <div className="validate-input input-group" id="Password-toggle">
                <a
                  href={() => false}
                  className="input-group-text bg-white text-muted"
                >
                  <i
                    className="zmdi zmdi-eye text-muted"
                    aria-hidden="true"
                  ></i>
                </a>
                <input
                  className="input100 border-start-0 form-control ms-0"
                  type="password"
                  placeholder="Password"
                  value={fields.userPassword}
                  {...$field("userPassword", (e) =>
                    onChange("userPassword", e.target.value)
                  )}
                />
                {errMsguserPassword}
              </div>
            </div>
            <div className="form-group col-md-3">
              <label className="custom-control custom-checkbox mt-7">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  onChange={this.handleCheckChange.bind(
                    this,
                    "userAllowShowAll"
                  )}
                  defaultChecked={fields.userAllowShowAll}
                />
                <span className="custom-control-label">
                  Allow Assign Engineer & Show All
                </span>
              </label>
            </div>

            <div className="form-group col-md-3">
              <label className="form-label">
                Status<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.status}
                onChange={this.handleSelectChange.bind(this, "status")}
                placeholder="Select Status"
                isClearable={true}
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "In Active" },
                ]}
              />
              {errMsgStatus}
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div
              className="btn-group me-2 sw-btn-group-extra submit_frm"
              role="group"
            >
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                Submit
              </button>

              <button
                className="btn btn-secondary"
                onClick={this.goBack.bind(this)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
